import axios from "axios";
import { all, fork, put, takeLatest } from "redux-saga/effects";
import { openToast } from "~/components/common/molecules/ToastNotification";
import history from "~/history";
import * as types from "~/store/partnerUser/types";
import * as userTypes from "~/store/user/userType";
import { client } from "~/utils/medproSDK";
import AppId from "~/utils/partner";

function* requestCreatePartnerUser({ id, partnerId }) {
  try {
    const response = yield client.createUserMomoByToken(
      { momoid: id },
      { partnerid: AppId }
    );
    const { token } = response.data;
    const userInfo = { ...response.data };

    yield put({ type: userTypes.GET_USER_INFO_BY_CODE_SUCCESS, userInfo });
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    window.localStorage.setItem("jwt", token);
    if (partnerId) {
      const passing = partnerId + "/chon-hinh-thuc-dat-kham";

      if (partnerId === "medpro") {
        history.push("/chon-benh-vien");
      } else {
        history.push(passing);
      }
    } else {
      history.push("/chon-benh-vien");
    }
  } catch (error) {
    console.log(error);
    openToast("Có lỗi xảy ra.", "error");
  }
}

function* watchRequestCreatePartnerUser() {
  yield takeLatest(types.CREATE_PARTNER_USER, requestCreatePartnerUser);
}

export default function* root() {
  yield all([fork(watchRequestCreatePartnerUser)]);
}
